import showVideo from './modules/video';
import tabs from './modules/tabs';
import feedbacksArr from './data/feedbacksArr';
import feedbacks from './modules/feedbacks';
import modal from './modules/modal';
import forms from './modules/forms';
import burger from './modules/burger';
import smoothScroll from './modules/smooth-scroll';
import timer from './modules/timer';
import slider from './modules/slider';
import { openModal } from './modules/modal';
import { accordionStatic } from './modules/accordion';
import { smartMessengersHandler } from './modules/smartMessengersHandler';

window.addEventListener('DOMContentLoaded', () => {
    const modalTimerId = setTimeout(() => {
        openModal(
            '.modal',
            modalTimerId,
            undefined,
            true
        );
    }, 70000);


    tabs('.tabheader__item', '.tabcontent', '.tabheader__items', 'tabheader__item_active');
    feedbacks('#feedback-row', 'button[data-more-feedbacks]', 'button_disabled', feedbacksArr);
    modal('[data-modal]', '.modal', modalTimerId);
    forms('#form', modalTimerId);
    showVideo('.video__speechtherapist');
    burger({
        menuSelector: '.header__menu',
        menuItemSelector: '.header__item',
        hamburgerSelector: '.hamburger',
        menuSelectorActive: 'header__menu_active',
        hamburgerSelectorActive: 'hamburger_active'
    });
    slider('.carousel__inner');
    accordionStatic(
        '.faq__descr',
        '.faq__btn',
        '.faq__wrapper'
    );
    smoothScroll('.pageup', 1920);
    timer('.timer', '2026-10-23');
    smartMessengersHandler();
});
